import { qportalApi } from './qportal-api';
import { convertModelToFormData } from './helpers';
const getAllPlacements = (status) => {
    return qportalApi.get('placement/GetAll', {
        params: status !== undefined ? { status } : {}
    });
};
const getPlacementById = (id) => {
    return qportalApi.get(`placement/GetById/${id}`);
};
const updatePlacementStatus = (request) => {
    return qportalApi.put('placement/UpdateStatus', request);
};
const updatePermanentPlacement = (request) => {
    const formData = convertModelToFormData(request);
    return qportalApi.postForm('placement/UpdatePlacement', formData);
};
const updateSecondmentPlacement = (request) => {
    const formData = convertModelToFormData(request);
    return qportalApi.postForm('placement/UpdatePlacement', formData);
};
const updateContractPlacement = (request) => {
    const formData = convertModelToFormData(request);
    return qportalApi.postForm('placement/UpdatePlacement', formData);
};
const PlacementApi = {
    getAllPlacements,
    getPlacementById,
    updatePlacementStatus,
    updatePermanentPlacement,
    updateSecondmentPlacement,
    updateContractPlacement
};
export default PlacementApi;
